/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Controls_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Style Guide Controls" |
*
* @param {Style_Guide_Controls_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_controls_aria_label = /** @type {((inputs?: Style_Guide_Controls_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Controls_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Controles du guide de style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Styleguide-Steuerelemente")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controlli della guida di stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Элементы управления стилем")
	if (locale === "es") return /** @type {LocalizedString} */ ("Controles de la guía de estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("样式指南控件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルガイドコントロール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टाइल गाइड नियंत्रण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Controles do guia de estilo")
	return /** @type {LocalizedString} */ ("Style Guide Controls")
});